<template>
  <div v-if="hasData" class="card shadow-sm">
    <div class="card-body">
      <div class="comment-content">
        <div v-html="item.data.comment" class="comment-text mb-1"></div>
        <div v-if="item.data.user" class="comment-author">
          <div class="d-flex align-items-center">
            <div>
              <div class="author-name">
                {{ item.data.user.name || $t("alarm.timeline.user") }}
              </div>
              <div class="author-email">
                {{ item.data.user.email }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  name: "CommentItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const hasData = computed(() => {
      return props.item?.data?.comment && props.item.data.comment.trim() !== '';
    });

    return {
      hasData,
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.comment-content {
  //background-color: #f8f9fa;
  padding: 1.25rem;
  border-radius: 0.5rem;
  .dark-layout & {
    background-color: $second-dark !important;
    border: 1px solid darken($second-dark, 5%);
  }
}

.comment-text {
  line-height: 1.6;
  color: #343a40;
  .dark-layout & {
    color: $theme-dark-label-color !important;
  }
}

.card-body {
  padding: 0.5rem !important;
}

.comment-author {
  border-top: 1px solid #e9ecef;
  padding-top: 1rem;
  margin-top: 1rem;
}

.author-name {
  font-weight: 600;
  color: #343a40;
  .dark-layout & {
    color: $theme-dark-label-color !important;
  }
}

.author-email {
  font-size: 0.85rem;
}
</style>
